import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import DateTZ, { TIMEZONE } from '../models/date/DateTZ';

export const DATE_FORMAT = {
  DAY: 'DD.MM.YYYY',
  TIME: 'HH:mm',
  REQUEST: 'YYYY-MM-DD',
  FULL: 'DD.MM.YYYY HH:mm:ss',
  FULL_NO_SEC: 'DD.MM.YYYY HH:mm'
};

export const MONTHS = {
  JANUARY: 0,
  FEBRUARY: 1,
  MARCH: 2,
  APRIL: 3,
  MAY: 4,
  JUNE: 5,
  JULY: 6,
  AUGUST: 7,
  SEPTEMBER: 8,
  OCTOBER: 9,
  NOVEMBER: 10,
  DECEMBER: 11
};

const DateFormat = ({ date = new Date(), format = DATE_FORMAT.DAY, parse = false }) => {
  const day = new DateTZ(date, parse).dayjs;

  return day ? day.format(format) : '';
};

DateFormat.propTypes = {
  format: PropTypes.string,
  parse: PropTypes.string,
  date: PropTypes.any
};

const DateTime = ({ date, tz = false }) => {
    const {t} = useTranslation(['common']);

    const day = new DateTZ(date).dayjs.tz(tz ? TIMEZONE : 'UTC');

  return day ? t('common:date.full', {date: `${day.date()} ${t(`common:date.months.${day.month()}`)} ${day.year()}`, time: day.format(DATE_FORMAT.TIME)}) : '';
};

DateTime.propTypes = {
    date: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string])
};

DateFormat.DateTime = DateTime;

const DateTimeSmall = ({ date, tz = false }) => {
    const {t} = useTranslation(['common']);

    const day = new DateTZ(date).dayjs.tz(tz ? TIMEZONE : 'UTC');

    return day ? day.format(DATE_FORMAT.FULL_NO_SEC) : '';
};

DateTimeSmall.propTypes = {
    date: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string])
};

DateFormat.DateTimeSmall = DateTimeSmall;

const Day = ({ date, parse = false }) => {
  const {t} = useTranslation(['common']);

  let day = new DateTZ(date, parse).dayjs;

  return day ? `${day.date()} ${t(`common:date.months.${day.month()}`)} ${day.year()}` : '';
};

Day.propTypes = {
  parse: PropTypes.string,
  date: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string])
};

DateFormat.Day = Day;

const Time = ({ date }) => {
  const day = new DateTZ(date).dayjs;

  return day ? day.format(DATE_FORMAT.TIME) : '';
};

Time.propTypes = {
  date: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string])
};

DateFormat.Time = Time;

const Request = ({ date, tz = false }) => {
  const day = (date instanceof DateTZ ? date.dayjs : new DateTZ(date).dayjs).tz(tz ? TIMEZONE : 'UTC');
  return day ? day.format(DATE_FORMAT.REQUEST) : '';
};

Request.propTypes = {
  date: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string])
};

DateFormat.Request = Request;

export default DateFormat;